import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchProducts } from "../lib/api";
import { useCart } from "../context/CartContext";
import { Reveal } from "../components/Reveal";

const Shop = () => {
  const [data, setData] = useState({ products: [], bundles: [] });
  const { addItem } = useCart();

  useEffect(() => {
    fetchProducts().then(setData).catch(() => {});
  }, []);

  return (
    <div className="bg-[#050505] text-white">
      <section className="max-w-[1400px] mx-auto px-6 md:px-12 pt-16 md:pt-24 pb-12 border-b border-white/10">
        <div className="font-display text-xs tracking-[0.3em] text-[#D10000] mb-4">
          THE COLLECTION
        </div>
        <h1
          className="font-display uppercase leading-[0.9] tracking-tight"
          style={{ fontSize: "clamp(3rem, 8vw, 7rem)" }}
        >
          Shop
        </h1>
        <p className="mt-6 max-w-xl text-white/60 leading-relaxed">
          Two formulas. One mission. Choose your weapon — or stack both.
        </p>
      </section>

      <section
        className="max-w-[1400px] mx-auto px-6 md:px-12 py-16 md:py-24"
        data-testid="shop-grid"
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {data.products.map((p, idx) => (
            <Reveal key={p.id} delay={idx * 0.1}>
              <article
                className="group relative bg-[#0A0A0A] border border-white/10 hover:border-[#D10000]/50 transition-all duration-500 overflow-hidden"
                data-testid={`shop-card-${p.id}`}
              >
                <Link
                  to={`/product/${p.id}`}
                  className="block aspect-[4/5] relative overflow-hidden"
                  data-testid={`shop-card-${p.id}-link`}
                >
                  <div
                    className="absolute inset-0"
                    style={{
                      background:
                        "radial-gradient(ellipse 80% 60% at 50% 30%, rgba(209,0,0,0.18), transparent 60%)",
                    }}
                  />
                  <img
                    src={p.image}
                    alt={p.name}
                    className="absolute inset-0 m-auto w-2/3 h-full object-contain transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute top-4 left-4 font-display text-xs tracking-[0.3em] text-white/60">
                    {p.count}
                  </div>
                </Link>
                <div className="p-6 md:p-8 border-t border-white/10 flex items-center justify-between gap-4">
                  <div>
                    <h3 className="font-display text-3xl tracking-tight uppercase leading-none">
                      {p.name}
                    </h3>
                    <p className="text-white/50 text-sm mt-2">{p.tagline}</p>
                    <div className="font-display text-2xl mt-3 tracking-wider">
                      ${p.price.toFixed(2)}
                    </div>
                  </div>
                  <button
                    onClick={() => addItem(p, 1)}
                    data-testid={`shop-add-${p.id}-button`}
                    className="bg-[#D10000] hover:bg-[#A30000] text-white font-display text-sm tracking-widest uppercase px-5 py-3"
                  >
                    Add
                  </button>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Shop;
